import { render, staticRenderFns } from "./GiftAbout.vue?vue&type=template&id=07819b32&scoped=true&"
import script from "./GiftAbout.vue?vue&type=script&lang=js&"
export * from "./GiftAbout.vue?vue&type=script&lang=js&"
import style0 from "./GiftAbout.vue?vue&type=style&index=0&id=07819b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07819b32",
  null
  
)

export default component.exports